import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=6f1d3bb2&scoped=true&"
import script from "./ButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&id=6f1d3bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d3bb2",
  null
  
)

export default component.exports